<div class="body-container" opacity="0.3">
    <div class="card">
        <div class="card-header">
            <h2>404</h2>
            <h6>Page Not Found :(</h6>
        </div>
    </div>
</div>